import { useCallback } from 'react';
import { SurveyResultsFilterNames } from 'models';
import { useSurveyResultsFilter } from 'hooks/useSurveyResultsFilter';
import { DEFAULT_SERVICE_ID } from 'modules/admin-panel/pages/results/utils';

export const useResetSurveyResultsFilter = () => {
	const { onChangeSurveyResultsFilter } = useSurveyResultsFilter();

	return useCallback(() => {
		onChangeSurveyResultsFilter({
			[SurveyResultsFilterNames.country]: undefined,
			[SurveyResultsFilterNames.city]: undefined,
			[SurveyResultsFilterNames.office]: undefined,
			[SurveyResultsFilterNames.businessUnit]: undefined,
			[SurveyResultsFilterNames.region]: undefined,
			[SurveyResultsFilterNames.roleId]: undefined,
			[SurveyResultsFilterNames.serviceId]: DEFAULT_SERVICE_ID,
		});
	}, [onChangeSurveyResultsFilter]);
};
